require("!!H:\\Proyectos Galeras Indie\\Vinta\\vinta Tinka\\VintaWebClient\\node_modules\\script-loader\\addScript.js")(require("!!H:\\Proyectos Galeras Indie\\Vinta\\vinta Tinka\\VintaWebClient\\node_modules\\raw-loader\\index.js!H:\\Proyectos Galeras Indie\\Vinta\\vinta Tinka\\VintaWebClient\\node_modules\\chart.js\\dist\\Chart.js"))


//////////////////
// WEBPACK FOOTER
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/~/script-loader!H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/~/chart.js/dist/Chart.js
// module id = ../../../../script-loader/index.js!../../../../chart.js/dist/Chart.js
// module chunks = 3